import { IFastFiltersUserSchema } from '../repositories/monolith-python/entities/schemas/FastFiltersUserSchema';
import { IUserPhoneSchema } from '../repositories/monolith-python/entities/user/UserPhoneSchema';
import { TUser } from '../types/user';

interface IPrepareUserParams {
  user?: IFastFiltersUserSchema | null;
}

export const prepareUser = ({ user }: IPrepareUserParams): TUser => {
  if (!user?.isAuthenticated) {
    return {
      isAuthenticated: false,
      userId: undefined,
    };
  }

  return {
    isAuthenticated: (user && user.isAuthenticated) || false,
    email: (user && user.email) || null,
    phones: (user && preparePhones(user.phones)) || null,
    userId: (user && user.userId) || null,
    cianId: (user && user.id) || null,
    displayName: (user && user.displayName) || null,
    webimHash: null,
    firstName: (user && user.firstName) || null,
    lastName: (user && user.lastName) || null,
    isAgent: (user && user.isAgent) || null,
  };
};

function preparePhones(phones?: IUserPhoneSchema[] | null): string[] | null {
  if (phones && phones.some(phone => !!phone.phone)) {
    return phones
      .map(phone => (phone.phone && `+${phone.phone.replace(/\D/g, '')}`) || null)
      .filter(Boolean) as string[];
  }

  return null;
}
